import { Controller } from "@hotwired/stimulus";
import template from "lodash/template";

export default class extends Controller {
  static targets = ["empty", "input", "list", "listItem", "remove", "template"];

  connect() {
    document.addEventListener("autocomplete.change", this.change.bind(this));
  }

  change(event) {
    this.addRecord(event);
    this.inputTarget.value = "";
  }

  addRecord(event) {
    const parsedTemplate = template(this.templateTarget.innerHTML);
    const data = {
      id: event.detail.value,
      name: event.detail.textValue,
      child_index: new Date().getTime(),
    };
    this.listTarget.insertAdjacentHTML("afterbegin", parsedTemplate(data));
    this.toggleEmptyState();
  }

  remove(event) {
    event.preventDefault();

    const index = this.removeTargets.findIndex((t) => t === event.target);
    const listItemElement = this.listItemTargets[index];
    listItemElement.remove();
    this.toggleEmptyState();
  }

  toggleEmptyState() {
    if (this.listItemTargets.length > 0) {
      this.emptyTarget.classList.add("hidden");
    } else {
      this.emptyTarget.classList.remove("hidden");
    }
  }
}
